export default "__VITE_ASSET__qT2ivZYz__"